// src/config/voices.ts
// Gemini-TTS prebuilt voice names per mode (display/picker only).
// Director notes + safety live server-side (functions/src/lib/voices.ts).
import type { Mode } from "@/types/roast";

/** Defaults: roast => "Fenrir" (energetic, gravelly), toast => "Puck" (bright/playful,
 *  delivered with a French accent + animated love-hate direction — see functions voices.ts). */
export const DEFAULT_VOICE: Record<Mode, string> = {
  roast: "Fenrir",
  toast: "Puck",
} as const;

/** Selectable prebuilt voices (subset of the 30-voice Gemini set); default leads each list. */
export const VOICE_OPTIONS: Record<Mode, string[]> = {
  roast: ["Fenrir", "Algenib", "Charon", "Orus", "Rasalgethi"],
  toast: ["Puck", "Algieba", "Charon", "Zephyr", "Aoede"],
} as const;
